'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/~/axios/lib/cancel/isCancel.js
// module id = 166
// module chunks = 24